import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./Pages/Login/Login";
import Panel from "./components/newcomponents/NewSource/Fms/Panel";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/panel" element={<Panel />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
